import type { Checkbox as PrimeCheckbox } from "primereact/checkbox";
import { forwardRef } from "react";

import type { CheckboxProps } from "./types-checkbox";
import { useCheckbox } from "./use-checkbox";
import { CheckboxView } from "./view-checkbox";

/** `Checkbox` do Prime com os ícones check/minus do Figma como padrão; rótulo, ajuda e erro vêm do `FormField`. */
export const Checkbox = forwardRef<PrimeCheckbox, CheckboxProps>(function Checkbox(props, ref) {
  const viewModel = useCheckbox(props, ref);

  return <CheckboxView {...viewModel} />;
});
Checkbox.displayName = "Checkbox";
